import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const Add = (props) => (<Svg viewBox="0 0 24 24" accessibilityRole="image" {...props}>
    <Path d="M12 5v14m-7-7h14" stroke={props?.fill ?? '#3999DE'} strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default Add;
